import React from 'react'
import BoxButton from './style/CPButton.css'

const CPButton = ({
  textLink,
  elementId,
}) => (
  <BoxButton
    id={elementId}
  >
    {textLink}
  </BoxButton>
)

export default CPButton
